import { render } from "./InsightFilters.vue?vue&type=template&id=a8126e6e"
import script from "./InsightFilters.vue?vue&type=script&lang=js"
export * from "./InsightFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__